import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';

import { DataListBasicComponent, DataListComponent } from './data-list.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { SSNModule } from 'app/pipes/ssn/ssn-pipe.module';
import { PercentageModule } from 'app/pipes/percentage/percentage-pipe.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [
    DataListComponent,
    DataListBasicComponent,
  ],
  imports: [
    CommonModule,
    FormlyModule,
    MatDividerModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    PhoneModule,
    SSNModule,
    PercentageModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    RouterModule
  ],
  exports: [
    DataListComponent,
    DataListBasicComponent,
  ],
  providers: []
})
export class DataListModule { }
